import { Icon } from "~/assets/icons/Icon";

import { ViewType } from "../../types/DecodedWidgetConfig.type";
import {
  GoogleAnalyticsPropertyRealtimeReport,
  GoogleAnalyticsPropertyReport,
} from "../../types/RenderableWidget.type";
import styles from "./RenderGoogleAnalyticsReport.module.scss";
import { BarChartView } from "./components/BarChartView/BarChartView";
import { CardsView } from "./components/CardsView/CardsView";
import { LineChartView } from "./components/LineChartView/LineChartView";
import { PieChartView } from "./components/PieChartView/PieChartView";
import { TableView } from "./components/TableView/TableView";

export const RenderGoogleAnalyticsReport = ({
  viewType,
  data,
}: {
  viewType: ViewType;
  data: GoogleAnalyticsPropertyReport | GoogleAnalyticsPropertyRealtimeReport;
}) => {
  // Check if there's no data to display
  const hasNoData =
    !data.rows ||
    data.rows.length === 0 ||
    (data.row_count !== undefined && data.row_count === 0);

  if (hasNoData) {
    return (
      <div className={styles.noDataContainer}>
        <Icon iconName="NoDashboardSites" width="5rem" height="4rem" />
        <p className={styles.noDataTitle}>No Data Available</p>
      </div>
    );
  }

  switch (viewType) {
    case "table":
      return <TableView data={data} />;
    case "cards":
      return <CardsView data={data} />;
    case "bar-chart":
      return <BarChartView data={data} />;
    case "line-chart":
      return <LineChartView data={data} />;
    case "pie-chart":
      return <PieChartView data={data} />;
    default:
      throw new Error("Unsupported chart type");
  }
};
